// Module
var code = "<div></div>\n";
// Exports
module.exports = code;